import { render, staticRenderFns } from "./Zimmerreservation.vue?vue&type=template&id=0c8b3dfa"
import script from "./Zimmerreservation.vue?vue&type=script&lang=js"
export * from "./Zimmerreservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports